// extracted by mini-css-extract-plugin
export default {"themeSpacing":"8px","backdrop":"SavingSurface_backdrop__vTR5","content":"SavingSurface_content__cUx6","progress":"SavingSurface_progress__oASV"};